import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=78056af5&scoped=true"
import script from "./simulation.vue?vue&type=script&lang=js"
export * from "./simulation.vue?vue&type=script&lang=js"
import style0 from "./simulation.vue?vue&type=style&index=0&id=78056af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78056af5",
  null
  
)

export default component.exports